import { Pipe, PipeTransform } from '@angular/core';
import { LOCATIONS } from '../../../ngrx/job-locations';

@Pipe({
  name: 'locationFormatPipe'
})
export class LocationFormatPipe implements PipeTransform {
  transform(location: string): any[] {
    return LOCATIONS[location] ? LOCATIONS[location] : location;
  }
}


// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/shared/pipes/location-format.pipe.ts